import iphoneStraight from "@/_assets/images/compatible-images/home/iphone18.png";
import iphoneTilt from "@/_assets/images/compatible-images/home/iphone17new.png";
import iphoneTiltRight from "@/_assets/images/compatible-images/home/iphoneairnew.png";
import Image from "next/image";

function IphoneCompatibleCard() {
  return (
    <div className="relative z-10 mt-5 flex h-full w-full flex-col items-center justify-center gap-6 md:gap-2 lg:mt-0 lg:flex-row lg:items-center lg:justify-between">
      <div className="order-1 flex h-full w-full flex-row items-center justify-center gap-2 px-2 md:gap-8 lg:order-1 lg:w-fit lg:flex-col">
        <button
          style={
            {
              "--btn-delay": "0.15s",
              "--btn-exit-delay": "1.05s",
            } as React.CSSProperties
          }
          className="compatible-anim-btn w-full rounded-full bg-white text-[10px] font-semibold text-black sm:py-2 sm:text-body-sm md:px-5 md:text-[11px] lg:min-w-[130px]"
        >
          iPhone 14
        </button>
        <button
          style={
            {
              "--btn-delay": "0.6s",
              "--btn-exit-delay": "0.7s",
            } as React.CSSProperties
          }
          className="compatible-anim-btn w-full rounded-full bg-white text-[10px] font-semibold text-black sm:py-2 sm:text-body-sm md:px-5 md:text-[11px] lg:min-w-[130px]"
        >
          iPhone 15
        </button>
        <button
          style={
            {
              "--btn-delay": "1s",
              "--btn-exit-delay": "0.35s",
            } as React.CSSProperties
          }
          className="compatible-anim-btn w-full rounded-full bg-white text-[10px] font-semibold text-black sm:py-2 sm:text-body-sm md:px-5 md:text-[11px] lg:min-w-[130px]"
        >
          iPhone 16
        </button>
        <button
          style={
            {
              "--btn-delay": "1.4s",
              "--btn-exit-delay": "0s",
            } as React.CSSProperties
          }
          className="compatible-anim-btn w-full rounded-full bg-white text-[10px] font-semibold text-black sm:py-2 sm:text-body-sm md:px-5 md:text-[11px] lg:min-w-[130px]"
        >
          iPhone 16 Pro
        </button>
      </div>
      <div className="order-3 hidden md:mt-20 md:flex lg:order-2">
        <div className="relative left-10 h-[300px] xl:left-20">
          <div className="compatible-anim-phone-left h-full">
            <Image
              src={iphoneTilt}
              alt="iPhone tilt left"
              height={500}
              className=""
            />
          </div>
        </div>
        <div className="relative z-10 h-[300px] md:-translate-y-10">
          <div className="compatible-anim-phone-center h-full">
            <Image
              src={iphoneStraight}
              alt="iPhone center"
              height={600}
              className=""
            />
          </div>
        </div>
        <div className="relative right-10 h-[300px] xl:right-20">
          <div className="compatible-anim-phone-right h-full">
            <Image
              src={iphoneTiltRight}
              alt="iPhone tilt right"
              height={500}
              className=""
            />
          </div>
        </div>
      </div>
      <div className="order-3 mt-5 block md:hidden">
        <div className="relative z-10 h-[300px]">
          <div className="compatible-anim-phone-mobile h-full">
            <Image
              src={iphoneStraight}
              alt="iPhone center"
              height={600}
              className=""
            />
          </div>
        </div>
      </div>
      <div className="order-2 flex h-full w-full flex-row items-center justify-center gap-2 px-2 md:gap-8 lg:order-3 lg:w-fit lg:flex-col">
        <button
          style={
            {
              "--btn-delay": "0.15s",
              "--btn-exit-delay": "1.05s",
            } as React.CSSProperties
          }
          className="compatible-anim-btn w-full rounded-full bg-white text-[10px] font-semibold text-black sm:py-2 sm:text-body-sm md:px-5 md:text-[11px] lg:min-w-[130px]"
        >
          iPhone 17
        </button>
        <button
          style={
            {
              "--btn-delay": "0.6s",
              "--btn-exit-delay": "0.7s",
            } as React.CSSProperties
          }
          className="compatible-anim-btn w-full rounded-full bg-white text-[10px] font-semibold text-black sm:py-2 sm:text-body-sm md:px-5 md:text-[11px] lg:min-w-[130px]"
        >
          iPhone SE
        </button>
        <button
          style={
            {
              "--btn-delay": "1s",
              "--btn-exit-delay": "0.35s",
            } as React.CSSProperties
          }
          className="compatible-anim-btn w-full rounded-full bg-white text-[10px] font-semibold text-black sm:py-2 sm:text-body-sm md:px-5 md:text-[11px] lg:min-w-[130px]"
        >
          iPhone 17 Air
        </button>
        <button
          style={
            {
              "--btn-delay": "1.4s",
              "--btn-exit-delay": "0s",
            } as React.CSSProperties
          }
          className="compatible-anim-btn w-full rounded-full bg-white text-[10px] font-semibold text-black sm:py-2 sm:text-body-sm md:px-5 md:text-[11px] lg:min-w-[130px]"
        >
          iPhone 13
        </button>
      </div>
    </div>
  );
}

export default IphoneCompatibleCard;
